import axios from 'axios'

export default class IncartCmsApis {
  /*eslint-disable */

  static getStoresApi() {
    const hostname = window.location.hostname
    // console.log('get stores-api by:', hostname)
    return axios({
      baseURL: 'https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/stores-api.json',
    }).then(({ data }) => data[hostname])
  }
}



// WEBPACK FOOTER //
// ./src/apis/incartCmsApis.js